import React from "react";
import LoadingScreen from "App/common/LoadingScreen/LoadingScreen";
import styles from "./MobileAppAuthRedirect.module.scss";

const MobileAppAuthRedirect = () => {
  return (
    <div className={styles["mobile-app-auth-redirect"]}>
      <LoadingScreen fixed />
    </div>
  );
};

export default MobileAppAuthRedirect;
